module.exports = __webpack_public_path__ + "assets/youllHeader-18ccf4c3b3eea2aa61a6664bf125e25d.png";